// extracted by mini-css-extract-plugin
export var borderRadius = "GalleryBadge-module--borderRadius--42ee9";
export var galleryBadge = "GalleryBadge-module--galleryBadge--5f7c6";